import React from "react";

export const NoMatch = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <h2>Nothing to see here!</h2>
    </div>
  );
}
